import React from 'react'
import { makeStyles } from '@mui/styles'
import { Todo } from '@/modules/todo/types'
import SimpleDrawer from '@/components/drawers/simple-drawer'
import TodoForm from '@/modules/todo/components/todo-form/todo-form'
import { Document } from '@/modules/document/types'

interface TodoFormDrawerProps {
  headline: string, // drawer prop -> gets forwarded
  open: boolean // drawer prop -> gets forwarded
  withTypeSelect?: boolean,
  withClientSelect?: boolean,
  minWidth?: number, // drawer prop -> gets forwarded
  todo?: Todo
  document?: Document,
  customer?: { id: string, name: string },
  onClose: () => void,
  onSave: (param) => void,
}

const useStyles = makeStyles(() => ({
  formWrapper: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    '& form > div': {
      padding: '0 30px',
    },
  },
  todoFormDrawer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    flexGrow: 1,
  },
}))

const TodoFormDrawer: React.FC<TodoFormDrawerProps> = (props) => {
  const classes = useStyles()

  const {
    todo,
    customer,
    withTypeSelect,
    withClientSelect,
    document,
    onSave,
  } = props

  return (
    <SimpleDrawer {...props} className={classes.todoFormDrawer}>
      <div className={classes.formWrapper}>
        <TodoForm
          todo={todo}
          customers= {customer ? [customer] : []}
          document={document}
          callbackAfterSave={onSave}
          withTypeSelect={withTypeSelect}
          withClientSelect={withClientSelect} />
      </div>
    </SimpleDrawer>
  )
}

export default TodoFormDrawer
